import { useState } from 'react'
import { AuthCard } from './AuthCard'
import { AuthInput } from './AuthInput'
import { AuthButton } from './AuthButton'
import { Lock, Save, ArrowLeft } from 'lucide-react'
import { AuthState } from '@/hooks/useCustomAuth'

interface NewPasswordFormProps {
  authState: any
  handleConfirmSignInWithNewPassword: (newPassword: string, userAttributes?: { name?: string }) => Promise<{ success: boolean; error?: any }>
  changeState: (newState: AuthState, tempEmail?: string, fromLogin?: boolean) => void
}

export function NewPasswordForm({
  authState,
  handleConfirmSignInWithNewPassword,
  changeState
}: NewPasswordFormProps) {
  console.log('✅ NewPasswordForm rendered - ready to accept new password')

  const [name, setName] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (newPassword !== confirmPassword) {
      return
    }

    try {
      const result = await handleConfirmSignInWithNewPassword(newPassword, { name: name.trim() })

      if (result?.success) {
        // The hook will handle state change to authenticated
      }
    } catch (error) {
      console.error('New password error:', error)
    }
  }

  const isFormValid = () => {
    return name.trim() && newPassword && confirmPassword && newPassword === confirmPassword && newPassword.length >= 8
  }

  return (
    <AuthCard
      title="Definir nova senha"
      subtitle="Por favor, defina uma nova senha para acessar o sistema pela primeira vez"
      icon={<Lock className="h-8 w-8 text-brand-dark" />}
    >
      <form onSubmit={handleSubmit} className="space-y-6" data-testid="new-password-form">
        <AuthInput
          label="Nome completo"
          type="text"
          value={name}
          onChange={setName}
          placeholder="Digite seu nome completo"
          required
          data-testid="new-password-name-input"
        />

        <AuthInput
          label="Nova senha"
          type="password"
          value={newPassword}
          onChange={setNewPassword}
          placeholder="Digite sua nova senha (mínimo 8 caracteres)"
          required
          error={authState.error?.code === 'InvalidPasswordException' ? authState.error.message : undefined}
          data-testid="new-password-input"
        />

        <AuthInput
          label="Confirmar nova senha"
          type="password"
          value={confirmPassword}
          onChange={setConfirmPassword}
          placeholder="Digite a nova senha novamente"
          required
          error={confirmPassword && newPassword !== confirmPassword ? 'As senhas não coincidem' : undefined}
          data-testid="new-password-confirm-input"
        />

        {authState.error && !['InvalidPasswordException'].includes(authState.error.code || '') && (
          <div
            className="bg-error/20 border border-error text-error px-4 py-3 rounded-monumenta text-sm"
            data-testid="new-password-error-message"
          >
            {authState.error.message}
          </div>
        )}

        <AuthButton
          type="submit"
          variant="primary"
          loading={authState.isLoading}
          disabled={!isFormValid()}
          className="w-full"
          icon={<Save className="h-5 w-5" />}
          data-testid="new-password-submit-button"
        >
          Definir nova senha
        </AuthButton>

        <AuthButton
          variant="ghost"
          onClick={() => changeState('signIn')}
          className="w-full"
          icon={<ArrowLeft className="h-4 w-4" />}
          data-testid="new-password-back-button"
        >
          Voltar ao login
        </AuthButton>
      </form>
    </AuthCard>
  )
}
